var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods_freeget"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.defaultGoods.guideContent)},on:{"click":function($event){return _vm.getVip($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }